import Box from '@paperstac/ui/lib/Box';
import DescriptionGridCell from '@paperstac/ui/lib/DescriptionGridCell';
import ErrorText from '@paperstac/ui/lib/ErrorText';
import LinkButton from '@paperstac/ui/lib/LinkButton';
import { ErrorMessage } from 'formik';
import React from 'react';
import NoteBulkChooser from '../../common/NoteBulkChooser/NoteBulkChooser';
import { INITIAL_NOTE_VALUES } from './CreateListingOverlay';

const CreatePoolListingFormSection = React.memo(({ formik, notes, stacked }) => {
  const handleSingleAsset = React.useCallback(
    () =>
      formik.setValues({
        isPool: false,
        notes: [INITIAL_NOTE_VALUES],
      }),
    [formik]
  );

  const handleAdd = React.useCallback(
    (id) => {
      formik.setFieldValue('notes', [...formik.values.notes, { id }]);
    },
    [formik]
  );

  const handleRemove = React.useCallback(
    (id) => {
      formik.setFieldValue(
        'notes',
        formik.values.notes.filter((n) => n.id !== id)
      );
    },
    [formik]
  );

  const handleSelectAll = React.useCallback(() => {
    formik.setFieldValue('notes', notes);
  }, [formik, notes]);

  const handleDeselectAll = React.useCallback(() => {
    formik.setFieldValue('notes', []);
  }, [formik]);

  return (
    <DescriptionGridCell term="Notes in Pool">
      <Box fontSize={1} my={3}>
        Select the mortgage notes that you want in this pool listing. A note can only be in one pool listing at a time.
        Create a new <LinkButton onClick={handleSingleAsset}>single-asset</LinkButton> listing to add an additional note
        to your account.
      </Box>
      <NoteBulkChooser
        chosen={formik.values.notes.map(({ id }) => id)}
        notes={notes}
        onAdd={handleAdd}
        onRemove={handleRemove}
        onSelectAll={handleSelectAll}
        onDeselectAll={handleDeselectAll}
      />
      <ErrorMessage name="notes" component={ErrorText} mt={3} />
    </DescriptionGridCell>
  );
});

CreatePoolListingFormSection.propTypes = {};

CreatePoolListingFormSection.defaultProps = {};

CreatePoolListingFormSection.displayName = 'CreatePoolListingFormSection';

export default CreatePoolListingFormSection;
